export default __webpack_public_path__ + "static/media/british.fe8ef721.svg";